import { PERMISSIONS } from '@/contants/permission.contants';
import { AccountListScreen } from '@/modules/accounts/UI';
import { BusinessParametersListScreen } from '@/modules/business-parameters/screens';
import { BusinessUnitList } from '@/modules/business-unit/screens';
import { CenterList } from '@/modules/center/screens';
import { CityList } from '@/modules/city/screens';
import { CountryList } from '@/modules/countries/screens';
import { CourseLineList } from '@/modules/course-lines/screens';
import { CourseTopicList } from '@/modules/course-topic/screens';
import { CourseList } from '@/modules/course/screens';
import { DistrictList } from '@/modules/district/screens';
import { EmployeeList } from '@/modules/employee/screens';
import { ProductLineList } from '@/modules/productlines/screens';
import { RolesListScreen } from '@/modules/roles/UI';
import SalesRankConfigScreen from '@/modules/sales-target-ranking/screens';
import { WardList } from '@/modules/wards/screens';
import {
  ApartmentOutlined,
  BlockOutlined,
  BookOutlined,
  ClusterOutlined,
  GlobalOutlined,
  GoldOutlined,
  HomeOutlined,
  IdcardOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import React from 'react';

export interface RouteConfig {
  key: string;
  path: string;
  label: string;
  icon?: React.ComponentType<{ style?: React.CSSProperties }>;
  permission?: string;
  children?: RouteConfig[];
  component?: React.ComponentType;
}

export const routeConfigs: RouteConfig[] = [
  {
    key: 'home',
    path: '/',
    label: 'Home',
    icon: HomeOutlined,
    // No permission required for home page
  },
  {
    key: 'accounts',
    path: '/accounts',
    label: 'Account',
    icon: IdcardOutlined,
    permission: PERMISSIONS.USERS.VIEW,
    component: AccountListScreen,
  },
  {
    key: 'roles',
    path: '/roles',
    label: 'Roles',
    icon: UserOutlined,
    permission: PERMISSIONS.ROLES.VIEW,
    component: RolesListScreen,
  },
  {
    key: 'center',
    path: '/center',
    label: 'Center',
    icon: GlobalOutlined,
    permission: PERMISSIONS.CENTRES.VIEW,
    component: CenterList,
  },
  {
    key: 'business-unit',
    path: '/business-unit',
    label: 'Business unit',
    icon: ApartmentOutlined,
    permission: PERMISSIONS.BUSINESS_UNITS.VIEW,
    component: BusinessUnitList,
  },
  {
    key: 'course-lines',
    path: '/course-lines',
    label: 'Course line',
    icon: BookOutlined,
    permission: PERMISSIONS.COURSE_LINES.VIEW,
    component: CourseLineList,
  },
  {
    key: 'courses',
    path: '/courses',
    label: 'Course',
    icon: BookOutlined,
    permission: PERMISSIONS.COURSE.VIEW,
    component: CourseList,
  },
  {
    key: 'course-topics',
    path: '/course-topics',
    label: 'Course topic',
    icon: BookOutlined,
    permission: PERMISSIONS.COURSE_TOPIC.VIEW,
    component: CourseTopicList,
  },
  {
    key: 'countries',
    path: '/countries',
    label: 'Countries',
    icon: GoldOutlined,
    permission: PERMISSIONS.COUNTRIES.VIEW,
    component: CountryList,
  },
  {
    key: 'cities',
    path: '/cities',
    label: 'Cities',
    icon: GoldOutlined,
    permission: PERMISSIONS.CITIES.VIEW,
    component: CityList,
  },
  {
    key: 'districts',
    path: '/districts',
    label: 'Districts',
    icon: ClusterOutlined,
    permission: PERMISSIONS.DISTRICTS.VIEW,
    component: DistrictList,
  },
  {
    key: 'wards',
    path: '/wards',
    label: 'Wards',
    icon: BlockOutlined,
    permission: PERMISSIONS.WARDS.VIEW,
    component: WardList,
  },
  {
    key: 'employees',
    path: '/employees',
    label: 'Employees',
    icon: UserOutlined,
    permission: PERMISSIONS.EMPLOYEE.VIEW,
    component: EmployeeList,
  },
  {
    key: 'product-lines',
    path: '/product-lines',
    label: 'Product line',
    icon: UserOutlined,
    permission: PERMISSIONS.PRODUCT_LINE.VIEW,
    component: ProductLineList,
  },
  {
    key: 'business-parameters',
    path: '/configure-business-parameters',
    label: 'Business Parameters',
    permission: PERMISSIONS.BUSINESS_PARAMETER.VIEW,
    component: BusinessParametersListScreen,
  },
  {
    key: 'sales-target-rank',
    path: '/configure-sales-target-rank',
    label: 'Sales Target Rank',
    icon: SettingOutlined,
    permission: PERMISSIONS.SALES_TARGET_RANK.VIEW,
    component: SalesRankConfigScreen,
  },
];
